<template>
  <v-card color="#f0f2f5" style="min-height: 100vh">
    <!-- Barra de herramientas premium -->
    <v-toolbar
      dark
      flat
      color="#2c3e50"
      style="position: sticky; top: 0; z-index: 10"
    >
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title class="font-weight-bold ml-2">
        Vista Previa de Adenda
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        :loading="isGenerating"
        color="success"
        depressed
        class="font-weight-bold px-6"
        @click="downloadPDF"
      >
        <v-icon left>mdi-file-download</v-icon>
        DESCARGAR PDF
      </v-btn>
    </v-toolbar>

    <!-- Vista previa en pantalla (A4 de Vuetify/HTML) -->
    <div class="preview-container">
      <div class="a4-sheet">
        <div class="document-sheet" id="adenda-content">
          <!-- Encabezado de preview (se ignora en el PDF) -->
          <div class="preview-header">
            <img
              src="/static/logo_sp.png"
              alt="Logo"
              class="preview-logo-img"
            />
          </div>

          <div class="doc-content-wrapper">
            <div class="doc-title-block">
              <h1 class="main-title">ADENDA AL CONTRATO PRIVADO DE COMPRA – VENTA</h1>
              <h2 class="sub-title">
                PRODUCTO: {{ adenda.TypeCultiveText || "MANGO" }}
                {{ adenda.TypeCropText || "" }}
              </h2>
              <h2 class="sub-title">
                CAMPAÑA {{ contrato.CmaName || "2025 / 2026" }}
              </h2>
            </div>

            <div class="doc-divider"></div>

            <div class="doc-body">
              <p>
                Conste por el presente documento, la <strong>Adenda al Contrato Privado de Compra - Venta</strong>, que celebran, de una parte,
                <strong>{{ contrato.PrdCardName || "---" }}</strong> con RUC N° <strong>{{ adenda.PrdRuc || "____________" }}</strong>, con domicilio fiscal en
                <strong>{{ adenda.PrdAddress || "____________" }}</strong>, debidamente representada por su titular Gerente Sr.
                <strong>{{ adenda.PrdRepresentative || "____________" }}</strong>, identificado con DNI N° <strong>{{ adenda.PrdDni || "____________" }}</strong>, en adelante denominado <strong>EL AGRICULTOR</strong>, y de la otra parte, la empresa <strong>SUNSHINE EXPORT S.A.C.</strong>, con RUC No 20329725431, con domicilio en CAR.TAMBOGRANDE-LAS LOMAS KM. 1077 PIURA - PIURA - TAMBO GRANDE, debidamente representada por su Gerente de Operaciones Agrícolas Sr. Carlos Daniel Sánchez Cueva, identificado con DNI N° 40685022, a quien en adelante se le denominará <strong>EL EXPORTADOR</strong>, de acuerdo a los términos y condiciones siguientes:
              </p>

              <h3 class="clause-title">PRIMERA.- ANTECEDENTE</h3>
              <p>
                Con fecha anterior, las partes celebraron el Contrato Privado de Cosecha - Compra - Venta de {{ adenda.TypeCultiveText || "Mango Convencional" }} para el fundo <strong>{{ adenda.FagName }}</strong> y el lote <strong>{{ adenda.FltName }}</strong>.
              </p>

              <h3 class="clause-title">SEGUNDA.- DE LA MODIFICACIÓN DE FECHAS</h3>
              <p>
                Mediante la presente Adenda, las partes de mutuo acuerdo convienen en modificar las fechas de vigencia originalmente pactadas para el lote de producción detallado, rigiendo a partir de la firma de este documento las siguientes condiciones:
              </p>
              
              <div class="annex-section">
                <v-simple-table dense class="annex-table">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td><strong>Fundo / Finca:</strong></td>
                        <td>{{ adenda.FagName }}</td>
                        <td><strong>Lote:</strong></td>
                        <td>{{ adenda.FltName }}</td>
                      </tr>
                      <tr>
                        <td><strong>Dirección Fundo:</strong></td>
                        <td colspan="3">{{ adenda.FagAddress }}</td>
                      </tr>
                      <tr>
                        <td><strong>Zona / Sub Zona:</strong></td>
                        <td>{{ adenda.ZonIDText }} / {{ adenda.SzoIDText }}</td>
                        <td><strong>Variedad:</strong></td>
                        <td>{{ adenda.VrtIDText || "---" }}</td>
                      </tr>
                      <tr>
                        <td><strong>Hectáreas:</strong></td>
                        <td>{{ adenda.FltHectares }} ha</td>
                        <td><strong>Plantas / Volumen:</strong></td>
                        <td>{{ adenda.FltPlants || "0" }} / {{ adenda.FltVolume || "0" }} t</td>
                      </tr>
                      <tr class="highlight-row">
                        <td><strong>NUEVA FECHA INICIO:</strong></td>
                        <td><strong>{{ formatDate(adenda.BeginDate) }}</strong></td>
                        <td><strong>NUEVA FECHA FIN:</strong></td>
                        <td><strong>{{ formatDate(adenda.EndDate) }}</strong></td>
                      </tr>
                      <tr>
                        <td><strong>Responsable Cobrador:</strong></td>
                        <td colspan="3"><strong>{{ adenda.ResponsibleFarmLot || "---" }}</strong></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <h3 class="clause-title">TERCERA.- RATIFICACIÓN</h3>
              <p>
                Las partes ratifican todos los demás términos, pactos y condiciones del Contrato original que no hayan sido expresamente modificados o sustituidos por la presente Adenda, obligándose a cumplirlos en su totalidad con absoluta buena fe.
              </p>

              <p class="mt-6">
                En señal de conformidad con todos los términos de la presente adenda, las partes la suscriben y firman en la ciudad de Piura, el {{ hoy.dia }} de {{ hoy.mes }} del {{ hoy.anio }}.
              </p>

              <!-- Firmas -->
              <div class="signatures-grid">
                <div class="sig-col">
                  <div class="sig-line"></div>
                  <div class="sig-name">EL AGRICULTOR</div>
                  <div class="sig-detail">DNI / RUC N°: ________________</div>
                </div>
                <div class="sig-col">
                  <div class="sig-line"></div>
                  <div class="sig-name">EL EXPORTADOR</div>
                  <div class="sig-detail">SUNSHINE EXPORT S.A.C.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Overlay de progreso -->
    <v-overlay :value="isGenerating" z-index="100">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="success"
        ></v-progress-circular>
        <div class="mt-2 grey--text">{{ progressText }}</div>
      </div>
    </v-overlay>
  </v-card>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "PdfAddendaProducer",
  props: {
    contrato: { type: Object, required: true },
    adenda: { type: Object, required: true },
  },
  data() {
    return {
      isGenerating: false,
      progressText: "",
      logoBase64: null,
    };
  },
  computed: {
    hoy() {
      const d = new Date();
      return {
        dia: d.getDate(),
        mes: new Intl.DateTimeFormat("es-ES", { month: "long" }).format(d),
        anio: d.getFullYear(),
      };
    },
  },
  mounted() {
    this.preloadLogo();
  },
  methods: {
    formatDate(val) {
      if (!val) return "---";
      return this.$moment(val).format(this.$const.FormatDateView || "DD/MM/YYYY");
    },
    async preloadLogo() {
      try {
        const response = await fetch("/static/logo_sp.png");
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve) => {
          reader.onloadend = () => {
            this.logoBase64 = reader.result;
            resolve();
          };
          reader.readAsDataURL(blob);
        });
      } catch (e) {
        console.error("Error preloading logo:", e);
      }
    },
    async downloadPDF() {
      if (this.isGenerating) return;
      this.isGenerating = true;
      this.progressText = "Generando PDF de la Adenda...";
      try {
        if (!this.logoBase64) await this.preloadLogo();

        const sanitize = (str) => {
          return str
            ? str.trim().replace(/[/\\?%*:|"<>]/g, "").replace(/\s+/g, "_")
            : "";
        };

        const element = document.getElementById("adenda-content");
        const prdName = sanitize(this.contrato.PrdCardName || "");
        const fundoName = sanitize(this.adenda.FagName || "");
        const filename = `ADENDA_${prdName}_${fundoName}.pdf`;

        // ESTRATEGIA DE CENTRADO ABSOLUTO E IGNORAR LOGO DE PREVIEW
        const opt = {
          margin: [25, 20, 20, 20], // Margen Top de 25mm para el logo insertado por jsPDF
          filename: filename,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2.2,
            useCORS: true,
            width: 642, // Equivale a 170mm a 96dpi (forzar ancho de captura de la hoja)
            ignoreElements: (el) => el.classList.contains("preview-header"),
          },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        };

        const worker = html2pdf().set(opt).from(element).toPdf().get("pdf");

        await worker.then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let j = 1; j <= totalPages; j++) {
            pdf.setPage(j);
            if (this.logoBase64) {
              pdf.addImage(this.logoBase64, "PNG", 20, 8, 36, 0);
            }
            pdf.setFontSize(8);
            pdf.setTextColor(150);
            pdf.text(
              `Adenda al Contrato - ${this.contrato.PrdCardName || ""} - Fundo ${this.adenda.FagName || ""} - Página ${j} de ${totalPages}`,
              20,
              287
            );
          }
        });

        await worker.save();
      } catch (error) {
        console.error("PDF Error:", error);
      } finally {
        this.isGenerating = false;
      }
    },
  },
};
</script>

<style scoped>
.preview-container {
  padding: 40px 20px;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
}

/* Contenedor que simula una hoja A4 real en pantalla */
.a4-sheet {
  width: 210mm;
  min-height: 297mm;
  background: white;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

/* El elemento que se captura es el contenido INTERNO del área imprimible */
.document-sheet {
  width: 170mm; /* Ancho imprimible (210 - 20 - 20) */
  margin: 0 auto; /* Centrado dentro de la hoja A4 */
  background: white;
}

.preview-header {
  height: 25mm;
  padding-top: 8mm;
  margin-bottom: 2mm;
}

.preview-logo-img {
  width: 36mm;
  height: auto;
}

.doc-content-wrapper {
  padding-bottom: 20mm;
  font-family: "Times New Roman", Times, serif;
  font-size: 11pt;
  line-height: 1.5;
  color: #1a1a1a;
}

.doc-title-block {
  text-align: center;
  margin-bottom: 20px;
}

.main-title {
  font-size: 14pt;
  font-weight: bold;
  text-decoration: underline;
}

.sub-title {
  font-size: 11pt;
  font-weight: bold;
}

.doc-divider {
  height: 1px;
  background: #000;
  margin: 15px 0;
}

.doc-body p {
  text-align: justify;
  margin-bottom: 10pt;
}

.clause-title {
  font-weight: bold;
  font-size: 11pt;
  margin-top: 14pt;
  margin-bottom: 6pt;
}

.annex-section {
  border: 1px solid #000;
  padding: 10px;
  background: #fafafa;
  margin: 15px 0;
}

.annex-table {
  width: 100%;
}

.annex-table td {
  padding: 4px 8px !important;
  font-size: 10.5pt !important;
  border: none !important;
}

.highlight-row {
  background: #eaeaea;
}

.signatures-grid {
  display: flex;
  justify-content: space-between;
  margin-top: 40pt;
}

.sig-col {
  width: 45%;
  text-align: center;
}

.sig-line {
  border-top: 1px solid #000;
  margin-bottom: 5px;
}

.sig-name {
  font-weight: bold;
  font-size: 10pt;
}

.sig-detail {
  font-size: 9.5pt;
  color: #555;
}
</style>
